<template>
  <div class="node-breadcrumb mb2">
    <router-link v-if="name_level0 && model.level==0" :to="{ name: routes.PLAN, params: { ...$route.params } }">

     {{labelStarts}} 
      <i class="cursor-breadcumb fa cursor-pointer fa-caret-right"></i>
      <span class="breadcumb-text-level0">{{ name_level0  }}</span>     
    </router-link>
<router-link v-if="name_level0 && model.level!=0" :to="{ name: routes.PLAN, params: { ...$route.params } }">

     {{labelStarts}} 
    </router-link>


  
        <template  v-for="{ id, attributes: { name } = {}} in parents" >
        <router-link         :key="id"
        :to="{ name: routes.CATEGORIES, params: { ...params, id } }"
      >
        <i class="fas fa-caret-right" />
     
        {{ capitalizefirst(name) }}
      
     
        
      </router-link>

      <router-link v-if="name_level3 && model.level>1 && name_level3_id==id"
        :key="id"
        :to="{ name: routes.CATEGORIES, params: { ...params, id } }"
      >
      
     
        <i class="fas fa-caret-right" />
        {{ name_level3 }}
     
      </router-link> 
    </template>

  </div>
</template>

<script>
import { translate } from "lib/vue/filters"
import { PlansStore } from "../lib/store";
import { routes } from "../lib/router";

export default {
  name: "Breadcrumb",
  filters: {
    translate
  },
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    json: {
     type: Array,
     default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelStarts: I18n.t("gobierto_plans.plan_types.show.starts") || "",
      parents: [],
      name_level0: this.name_level0,
      name_level2: this.name_level2,
      name_level3: this.name_level3,
      name_level3_id: this.name_level3_id,
      
    }
  },
  computed: {
    routes() {
      return routes
    },
    params() {

      // this.$route.params.slug = "esdevenir-un-referent-en-la-formacio-professional-i-universitaria"
      // this.$route.params.id = 17973
      return this.$route.params
    }
  },
  created() {
    const { plainItems, options } = PlansStore.state
    const { last_level, max_category_level } = options
    this.lastLevel = last_level;
    const parents = []
    const findParents = (model) => {
      const { level, attributes: { category_id, term_id } = {} } = model

      const id = (level === last_level) ? category_id : term_id
      const parent = plainItems.find(d => +d.id === id)
      if (parent) {
        // const ooo = parent[0].attributes.name

        parents.push(parent)
        findParents(parent)
      }
      
    }


    this.capitalizefirst = (text) => {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
      
    }


    findParents(this.model)
    // filter the last category, since the view is shared with the next to last category.
    // then, reverse the items in order to show them from minor level to higher
    this.parents = parents.filter(({ attributes: { level } = {} }) => level !== max_category_level ).reverse()
    if(this.lastLevel==3){
      if(this){
        if(( this.model.level==0  )){
          this.name_level0 = this.model.attributes.name
          this.slug = this.model.attributes.slug
        if(this.name_level0){
            this.name_level0 = this.name_level0.toString()
            this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
          }
        }
      }

      if(this){
        if(this.model.level==1 && this.json != "undefined"){
          if(this.json.length>0){
            if(parents.length>0 && parents.length<2){
              
            this.name_level0 = parents[0].attributes.name
          if(this.name_level0){
            this.name_level0 = this.name_level0.toString()
            this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
          }
            }else{
              for( var k1 = 0;k1 < this.json.length;k1++){
                for(var k2 = 0;k2 <this.json[k1].children.length;k2++){
                  for(var k3 = 0;k3 <parents.length;k3++){
                    if(parents[k3].id == this.json[k1].children[k2].term_id){
                      this.name_level0 = this.json[k1].attributes.name
                      this.name_level0 = this.name_level0.toString()
                      this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
                    }
                  }
                }
              }
            }
          }
        }
      }
    
      if(this){
        if(this.model.level==3 && this.json != "undefined"){
          if(this.json.length>0){
            if(this && this.json!=null){
              for(var k5 = 0;k5 <this.json.length;k5++){
                for(var k6 = 0;k6 <this.json[k5].children.length;k6++){
                  for(var k7 = 0;k7 <this.json[k5].children[k6].children.length;k7++){
                    for(var k8 = 0;k8 <this.json[k5].children[k6].children[k7].children.length;k8++){
                      if(this.model.id == this.json[k5].children[k6].children[k7].children[k8].id){
    //"json.0.children.0.children.0.children.0.id"
                        this.name_level0 = this.json[k5].attributes.name
                        this.name_level2 = this.json[k5].children[k6].attributes.name
                        this.name_level3 = this.json[k5].children[k6].children[k7].attributes.name
                        this.name_level3_id = this.json[k5].children[k6].id
    //"json.0.attributes.name"
                        if(this.name_level0 && this.name_level3 && this.name_level2){
                          this.name_level0 = this.name_level0.toString()
                          this.name_level2 = this.name_level2.toString()
                          this.name_level3 = this.name_level3.toString()
                          this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
                          this.name_level2 = this.name_level2.charAt(0).toUpperCase() + this.name_level2.slice(1).toLowerCase()
                          this.name_level3 = this.name_level3.charAt(0).toUpperCase() + this.name_level3.slice(1).toLowerCase()
                        }
                        //"json.0.children.0.attributes.name"
                        //"json.0.children.0.children.0.attributes.name"
                      }    
                    }
                  }
                }
              }
            }
          }
        }
        
      }
    }
  if(this.lastLevel==2){
      if(this){
        if(( this.model.level==0  )){
          this.name_level0 = this.model.attributes.name
          this.slug = this.model.attributes.slug
        if(this.name_level0){
            this.name_level0 = this.name_level0.toString()
            this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
          }
        }
      }

      if(this){
        if(this.model.level==1 && this.json != "undefined"){
          if(this.json.length>0){
            if(parents.length>0 && parents.length<2){
              
            this.name_level0 = parents[0].attributes.name
          if(this.name_level0){
            this.name_level0 = this.name_level0.toString()
            this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
          }
            }else{
              for( var k1 = 0;k1 < this.json.length;k1++){
                for(var k2 = 0;k2 <this.json[k1].children.length;k2++){
                  for(var k3 = 0;k3 <parents.length;k3++){
                    if(parents[k3].id == this.json[k1].children[k2].term_id){
                      this.name_level0 = this.json[k1].attributes.name
                      this.name_level0 = this.name_level0.toString()
                      this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
                    }
                  }
                }
              }
            }
          }
        }
      }
    
      if(this){
        if(this.model.level==2 && this.json != "undefined"){
          if(this.json.length>0){
            if(this && this.json!=null){
              for(var k5 = 0;k5 <this.json.length;k5++){
                for(var k6 = 0;k6 <this.json[k5].children.length;k6++){
                  for(var k7 = 0;k7 <this.json[k5].children[k6].children.length;k7++){
                    if(this.model.id == this.json[k5].children[k6].children[k7].id){
 /// "json.0.children.0.attributes.name"
//"json.0.children.0.children.0.id"

                      this.name_level0 = this.json[k5].attributes.name
                      this.name_level2 = this.json[k5].children[k6].attributes.name
                      this.name_level3 = this.json[k5].children[k6].attributes.name
                      //this.name_level3 = this.json[k5].children[k6].children[k7].attributes.name
                      this.name_level3_id = this.json[k5].children[k6].attributes.term_id
  //"json.0.attributes.name"
                      if(this.name_level0 && this.name_level3 && this.name_level2){
                        this.name_level0 = this.name_level0.toString()
                        this.name_level2 = this.name_level2.toString()
                        this.name_level3 = this.name_level3.toString()
                        this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
                        this.name_level2 = this.name_level2.charAt(0).toUpperCase() + this.name_level2.slice(1).toLowerCase()
                        this.name_level3 = this.name_level3.charAt(0).toUpperCase() + this.name_level3.slice(1).toLowerCase()
                      }
                      //"json.0.children.0.attributes.name"
                      //"json.0.children.0.children.0.attributes.name"
                    }    
                  }
                }
              }
            }
          }
        }
        
      }
    }
  

  
  },
    watch: {
    model: {
      handler: function() {
        if(this){
          if(( this.model.level==0  )){
            this.name_level0 = this.model.attributes.name
            if(this.name_level0){
              this.name_level0 = this.name_level0.toString()
              this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
            }
          }
        }

        if(this){
          if(this.model.level==1 && this.json != "undefined"){
            if(this.json.length>0){
              if(parents.length>0 && parents.length<2){
                
              this.name_level0 = parents[0].attributes.name
            if(this.name_level0){
              this.name_level0 = this.name_level0.toString()
              this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
            }

              }else{
                for( var k1 = 0;k1 < this.json.length;k1++){
                  for(var k2 = 0;k2 <this.json[k1].children.length;k2++){
                    for(var k3 = 0;k3 <parents.length;k3++){
                      if(parents[k3].id == this.json[k1].children[k2].term_id){
                        this.name_level0 = this.json[k1].attributes.name
                        this.name_level0 = this.name_level0.toString()
                        this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
                      }
                    }
                  }
                }
              }
            }
          }
        }

        if(this){
          if(this.model.level==3 && this.json != "undefined"){
            if(this.json.length>0){
              if(this && this.json!=null){
                for(var k5 = 0;k5 <this.json.length;k5++){
                  for(var k6 = 0;k6 <this.json[k5].children.length;k6++){
                    for(var k7 = 0;k7 <this.json[k5].children[k6].children.length;k7++){
                      for(var k8 = 0;k8 <this.json[k5].children[k6].children[k7].children.length;k8++){
                        if(this.model.id == this.json[k5].children[k6].children[k7].children[k8].id){
                          this.name_level0 = this.json[k5].attributes.name
                          this.name_level2 = this.json[k5].children[k6].attributes.name
                          this.name_level3 = this.json[k5].children[k6].children[k7].attributes.name
                          if(this.name_level0 && this.name_level3 && this.name_level2){
                            this.name_level0 = this.name_level0.toString()
                            this.name_level2 = this.name_level2.toString()
                            this.name_level3 = this.name_level3.toString()
                            this.name_level0 = this.name_level0.charAt(0).toUpperCase() + this.name_level0.slice(1).toLowerCase()
                            this.name_level2 = this.name_level2.charAt(0).toUpperCase() + this.name_level2.slice(1).toLowerCase()
                            this.name_level3 = this.name_level3.charAt(0).toUpperCase() + this.name_level3.slice(1).toLowerCase()
                          }
                        }    
                      }
                    }
                  }
                }
              }
            }
          }
        }
     
      },
      deep: true
    }
  }
}
</script>